export default __webpack_public_path__ + "static/infinity-rewards-7250f4d3d29b59c4a2c92ff8c1d3af0c.png";